import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/floating-cta.css';

const FloatingCta = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [visible, setVisible] = useState(false);
	const [expanded, setExpanded] = useState(false);

	const handleContactClick = useCallback((e) => {
		e.preventDefault();
		setExpanded(false);
		const isHome = window.location.pathname === '/' || window.location.pathname === '';
		if (isHome) {
			const el = document.getElementById('contact');
			if (el) el.scrollIntoView({ behavior: 'smooth' });
		} else {
			navigate('/#contact');
			setTimeout(() => {
				const el = document.getElementById('contact');
				if (el) el.scrollIntoView({ behavior: 'smooth' });
			}, 200);
		}
	}, [navigate]);

	useEffect(() => {
		const onScroll = () => {
			setVisible(window.pageYOffset > 400);
		};
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	if (!visible) return null;

	return (
		<div className={`floating-cta ${expanded ? 'floating-cta-expanded' : ''}`}>
			{expanded && (
				<div className="floating-cta-menu">
					<a href="tel:0656558610" className="floating-cta-option">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
						</svg>
						<span>{t('floatingCta.callNow')}</span>
					</a>
					<a href="mailto:info@ingegneriabernasconi.it" className="floating-cta-option">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
							<polyline points="22,6 12,13 2,6"/>
						</svg>
						<span>{t('floatingCta.writeUs')}</span>
					</a>
					<a href="#contact" className="floating-cta-option" onClick={handleContactClick}>
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
						</svg>
						<span>{t('floatingCta.freeConsultation')}</span>
					</a>
				</div>
			)}
			<button
				className="floating-cta-button"
				onClick={() => setExpanded(!expanded)}
				aria-label={t('floatingCta.contactUs')}
			>
				{expanded ? (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
						<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
					</svg>
				) : (
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
					</svg>
				)}
			</button>
		</div>
	);
};

export default FloatingCta;
